import styled from 'styled-components'
import Colors from 'spartacus/styles/colors'

export const Container = styled.span<{ valid: boolean; touched: boolean }>`
  display: block;
  display: flex;
  align-items: center;
  color: ${({ valid, touched }): string =>
    !touched || valid ? Colors.util.fade(Colors.UI.Black, 0.46) : Colors.Brand.Secondary5};

  svg {
    width: 12px;
    height: 12px;
    margin-right: 4px;
    color: ${({ valid }): string => (valid ? Colors.Brand.Primary1 : Colors.Brand.Secondary5)};
  }
`
